<template>
  <div class="protocol login-protocol">
    <navigation>《会员礼包服务协议》</navigation>
    <section class="content">
      <p class="text tab-2">本协议是用户（下称“用户”或“您”）与会员礼包服务的运营商重庆领易付科技有限公司（下称“领易付”）之间就您购买及使用会员礼包所订立的协议。请您仔细阅读本协议，您点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。</p>
      <p class="text tab-2">第一条 相关定义</p>
      <p class="text tab-2">1.1用户：指平台注册用户，用户经领易付审核资格通过后可购买会员礼包。</p>
      <p class="text tab-2">1.2平台：指为会员礼包服务提供展示的“天美贷手机APP”（运营方：重庆市崇天小额贷款有限公司）。</p>
      <p class="text tab-2">1.3会员礼包：是为领易付用户打造的付费权益服务礼包，礼包中包含由领易付及领易付的合作服务方共同为用户提供的各类服务内容。</p>
      <p class="text tab-2">1.4合作服务方：指与领易付合作的为用户提供包括但不限于支付转账、消费、娱乐、资讯、交通出行、生活服务等各类服务的主体。合作服务方与用户之间的服务条款请参考附件一：《橡树生活权益平台权益服务协议》。</p>
      <p class="text tab-2">第二条 本站协议条款的确认和接纳</p>
      <p class="text tab-2">2.1本站所提供的会员礼包以及相关优惠活动的所有权和解释权归领易付所有。</p>
      <p class="text tab-2">2.2用户点击同意本协议即视为用户确认同意接受会员礼包相关服务的条款，且同意按本协议内容履行。因用户违反协议、使用规则等导致的一切法律后果，用户同意承担相应法律责任。</p>
      <p class="text tab-2">2.3您确认在您开始使用会员礼包服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>
      <p class="text tab-2">2.4领易付保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容等相关权利。</p>
      <p class="text tab-2">第三条 礼包服务时间</p>
      <p class="text tab-2">3.1 用户确认购买会员礼包服务后，系统即自动为您提供各项权益服务，用户应在购买时所展示的权益服务期限内使用。具体参与条件以会员礼包的体验、购买流程为准。</p>
      <p class="text tab-2">第四条 礼包权益</p>
      <p class="text tab-2">4.1您购买会员礼包后，即可享受礼包内包含的各项服务。礼包所包含的服务内容详见购买页面。您可在礼包有效期内选择其中的一项或多项在对应的服务有效期内使用。</p>
      <p class="text tab-2">4.2会员礼包中的各项具体的服务内容由领易付或领易付的合作服务方提供。如用户希望使用由合作服务方提供的服务内容的，则需要另行在合作服务方平台进行购买和使用，并遵循该平台使用规则。领易付不对合作服务方提供的服务内容及用户与合作服务方的交易承担责任，但会在合理范围内协助用户与合作服务方协商沟通。</p>
      <p class="text tab-2">4.3为更好的向用户提供服务，领易付有权基于自身业务发展需要调整部分或全部会员礼包权益的内容。领易付就前述调整将在相应服务页面进行通知或公告，您可以通过平台或本页面查询最新的权益内容。</p>
      <p class="text tab-2">第五条 使用注意事项</p>
      <p class="text tab-2">5.1用户在平台选择跳转至会员礼包服务的界面时，同意授权平台向领易付及领易付的合作公司上海瓴峰科技有限公司共享用户的天美贷注册账户相关信息。领易付保留审核用户是否享有购买会员礼包资格的权利。</p>
      <p class="text tab-2">5.2用户确认通过平台公示或平台实际支持的支付方式购买会员礼包，包括但不限于：</p>
      <p class="text tab-2">5.2.1通过领易付合作的第三方支付机构（支付宝（中国）网络技术有限公司、宝付网络科技（上海）有限公司等）提供的第三方支付方式进行支付。</p>
      <p class="text tab-2">5.2.2通过领易付的合作公司（上海瓴峰科技有限公司等）提供的第三方支付方式进行支付。</p>
      <p class="text tab-2">5.3针对用户购买会员礼包需支付的礼包费用，平台根据礼包权益内容向用户提供不同的支付周期，具体以平台服务页面展示的情况为准：</p>
      <p class="text tab-2">5.3.1一次性支付完成：付款成功即为有效购买，会员礼包的相关权益将在有效购买后自动开通。</p>
      <p class="text tab-2">5.3.2 分期支付完成：针对礼包费用的消费分期订单生成即为有效购买（消费分期订单生成规则以平台相关服务页面公示的服务内容为准），会员礼包相关权益将在有效购买后自动开通，用户应当按照前述消费分期订单显示的信息按时或提前完成前述消费分期订单的支付。</p>
      <p class="text tab-2">5.4会员礼包服务开通后，用户应谨慎合理的保存自己的天美贷账户，不得将账户借给他人使用，否则用户应承担由此产生的全部责任。同时领易付及/或天美贷平台在该种情况下有权做出独立判断，可暂停或关闭用户参与资格。</p>
      <p class="text tab-2">5.5用户同意并授权，领易付可通过短信形式向其发送会员礼包开通及礼包期限提醒信息。</p>
      <p class="text tab-2">5.6用户同意，其应合理使用其享有的会员礼包，除为实现用户自身的会员礼包利益外，不得利用会员礼包非法获利，不得以任何形式售卖其所享有的权益，不得滥用其所享有的权益，如因用户行为致领易付合理怀疑或领易付判定为不当行为的，领易付有权暂停或关闭用户的会员礼包权益，用户已支付的会员费用不予退还；用户尚未清偿完毕的礼包费用的消费分期订单应全部提前到期，用户应立即清偿该笔消费分期订单项下的所有待支付款项。此外，用户需承担因此引起的相应责任及后果。</p>
      <p class="text tab-2">5.7用户理解并同意，会员礼包购买后原则上不支持退款。</p>
      <p class="text tab-2">第六条 协议更新</p>
      <p class="text tab-2">6.1根据国家法律法规变化及网站运营需要，领易付有权以公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在平台上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与领易付的协议。如用户继续使用领易付提供的服务的，即视为同意更新后的协议。领易付建议您在使用服务之前阅读本协议及相关公告。</p>
      <p class="text tab-2">第七条 法律管辖和适用</p>
      <p class="text tab-2">7.1本协议是由您与领易付共同签订的，适用于您关于会员礼包的全部行为，领易付有最终的解释权。</p>
      <p class="text tab-2">7.2本协议不涉及您与其他用户之间以及因使用会员礼包服务而产生的法律关系及法律纠纷。但您在此同意将全面接受并履行与其他用户在以及使用会员礼包服务签订的任何电子法律文本，并承诺按照该法律文本享有和（或）放弃相应的权利、承担和（或）豁免相应的义务。</p>
      <p class="text tab-2">7.3如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，则应认为该条款可与本协议相分割，并可被尽可能接近各方意图的、能够保留本协议要求的经济目的的、有效的新条款所取代，而且，在此情况下，本协议的其他条款仍然完全有效并具有约束力。</p>
      <p class="text tab-2">7.4本协议及其修订的有效性、履行与本协议及其修订效力有关的所有事宜，将受中国大陆法律管辖，任何争议仅适用中国法律。</p>
      <p class="text tab-2">7.5因本协议所引起的用户与平台、领易付的任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交重庆市渝中区有管辖权的人民法院诉讼解决。</p>
      <p class="text tab-2">第八条 通知与送达</p>
      <p class="text tab-2">8.1 本协议履行期间，领易付可以通过电子方式或邮寄方式向您传递书面通知或诉讼文书（包括但不限于一审、二审、执行、仲裁文书），按照您在平台提供的通讯地址交邮后的第三个自然日即视为送达；书面通知的形式还包括领易付在服务页面的公告或信息推送、平台公告、向您发送电子邮件、站内信、手机短信等电子方式，在采用电子方式进行书面通知的情况下，公告/发送当日即视为送达。领易付有权决定以前述任何一种或几种形式书面通知您。领易付以多种方式向您发送通知的，通知送达时间以最先送达的为准。</p>
      <p class="text tab-2">8.2 如您在平台登记的地址或联系方式有变更的，应当提前7日通知平台及领易付。否则，视为原地址或联系方式继续有效。领易付或司法机关按照原地址或联系方式向您送达书面通知的，不论是否经签收均视为有效送达。</p>
      <p class="text tab-2">第九条 责任限制和免除</p>
      <p class="text tab-2">9.1 因下列原因导致的风险，领易付不承担责任：</p>
      <p class="text tab-2">9.1.1 因提供会员礼包相关服务的相关系统维护或升级，或系统运行导致出现故障、差错或展示有误的，您同意领易付可以自行或通过第三方采取更正差错、暂停服务或其他适当纠正措施。</p>
      <p class="text tab-2">9.1.2 因台风、地震、海啸、洪水、停电、雷电、罢工、骚乱、政府行为、司法行政命令、战争或恐怖袭击等不可抗力原因。</p>
      <p class="text tab-2">9.1.3 您操作不当或通过其他非领易付认可的方式使用会员礼包服务的。</p>
      <p class="text tab-2">9.1.4 因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、电信设备故障、银行原因、第三方服务瑕疵、政府行为等原因。</p>
      <p class="text tab-2">9.1.5 本协议有效期内，因国家相关主管部门颁布、变更的法律、法规、规章、规定、指引、通知、政策及其他规范性文件等导致领易付不能提供约定服务的，不视为违约，各方可根据相关规定变更协议内容或提前终止本协议。</p>
      <p class="text tab-2">第十条 协议变更与解除</p>
      <p class="text tab-2">10.1 领易付有权根据业务变化情况单方修改本协议中与您有关的权利义务。一旦协议条款变更，领易付将在相关服务页面进行公示，除法律法规或监管规定另有强制性规定外，经修订的内容一经公示，立即生效。如您不同意修改后的协议，则应当立即停止使用领易付提供的会员礼包服务；否则，将视为您同意并接受修改后的协议。我们提醒您注意，停止使用领易付提供的服务后，您在本协议更新前使用领易付提供的服务所负的债务将继续有效。</p>
      <p class="text tab-2">10.2 如发生下列情形之一的，领易付有权终止本协议：</p>
      <p class="text tab-2">10.2.1 您主动注销天美贷账户。</p>
      <p class="text tab-2">10.2.2 您的天美贷账户被注销。</p>
      <p class="text tab-2">10.2.3 您冒用他人名义、盗用他人账户使用领易付提供的服务。</p>
      <p class="text tab-2">10.3.4 您使用领易付提供的服务从事不法交易行为，包括但不限于洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品及其他监管机构、司法机构等认为不得使用领易付提供的服务进行交易的物品等。</p>
      <p class="text tab-2">10.3.5 您利用领易付进行套现。</p>
      <p class="text tab-2">10.3.6 您从事任何可能侵害领易付或天美贷系统的行为。</p>
      <p class="text tab-2">10.3.7 您违反任何法律法规、或本协议的各项规则的。</p>
      <p class="text tab-2">第十一条 其他</p>
      <p class="text tab-2">11.1 如因不可抗力或其它无法控制的原因使本站活动服务无法及时提供或无法按本协议进行的，领易付会合理地尽力协助处理善后事宜。</p>
      <!-- <p class="text tab-2">11.2如用户针对会员礼包服务或退款事宜有任何疑问，请联系客服：4006662172。</p> -->
      <p class="text tab-2">11.2 用户除遵守该用户协议外，仍应同时遵守平台发布的《天美贷平台用户注册协议》。</p>
      <p class="text tab-2">11.3 涉及合作服务方提供的会员权益内容的，用户应同时遵守合作服务方的相关条款。 </p>
      <p class="text tab-2">附件协议：</p>
      <p class="text tab-2">
        <a href="https://cdn.xiangshuheika.com/h5/agreement/chongtian.html"> 附件一：《橡树生活权益平台权益服务协议》</a>
      </p>
      <p class="text tab-2">
        <router-link to="/protocol/auth"> 附件二：《用户授权协议》</router-link>
      </p>
    </section>
    <p data-sensors-exposure-property-page_status="page_bottom" data-sensors-exposure-event-name="general_event">&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>

<script>
import axios from '@/assets/axios'
export default {
  name: 'vipProtocol',
  async created () {
    const { data } = await axios.post('/order/v1/supplierAgreementVersion')
    if (data.success) {
      if (data?.data?.showNewVersion === 'Y') {
        this.$router.replace('/protocol/vip-lf')
      }
    }
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.login-protocol {
  background-color: white;

  .content {
    padding: 0 48px;

    .title {
      font-weight: bolder;
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
      margin-top: 10px;
    }

    .text {
      color: #333333;
      font-size: 28px;
      text-indent: 40px;
      line-height: 44px;
    }

    .text:last-child {
      margin-bottom: 10px;
    }

    .underline {
      text-indent: 40px;
      font-weight: bold;
      text-decoration: underline;
    }

    .underline:last-child {
      margin-bottom: 10px;
    }
  }
}
</style>
